import { defineComponent as _defineComponent } from 'vue'
import { fetchGetProductionNcSetting } from '@/apis/materialList'
import { httpRequest } from '@/apis/request'
import router from '@/router'
import store from '@/store'
import { translate } from '@/util/commonFun'
import { buryPointApi } from '@/util/commonFuncs'
import {
  dealPlankListLabelID,
  dealPreLayoutDataLabelID,
} from '@/util/dealPaibanData'
import { dealPreLayoutSetting } from '@/views/materialsList/util/preLayoutDeal'
import Vue from 'vue'
import { ref } from 'vue'

import { BatchHistoryType } from '../types/batchHistory'
import { getPlankOrderInfo } from '../util/dealData'
import MTaskCard from './m-task-card.vue'

interface PropsType {
  batchHistory: BatchHistoryType
  isLoadingHistory?: boolean
  historyIndex?: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'm-batch-history-item',
  props: {
    batchHistory: null,
    isLoadingHistory: { type: Boolean },
    historyIndex: null
  },
  emits: ['onDelete'],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  batchHistory: BatchHistoryType
  isLoadingHistory?: boolean
  historyIndex?: number
}




const isLoading = ref(false)

async function handleToMaterial() {
  buryPointApi('task', 'task_to_material')
  const taskList = props.batchHistory.taskList
  isLoading.value = true
  resetSomeVuex()
  if (taskList[0] && taskList[0].paiban_json) {
    const paibanJson = await httpRequest.get(taskList[0].paiban_json)
    isLoading.value = false
    store.commit('setBatchPaiban', paibanJson)
    router.push({
      path: '/materialList',
      query: {
        isBatch: '1',
      },
    })
  }
}

async function handleToPaiban() {
  buryPointApi('task', 'task_to_paiban')
  const taskList = props.batchHistory.taskList
  isLoading.value = true
  resetSomeVuex()

  if (taskList[0] && taskList[0].paiban_json) {
    const paibanJson = await httpRequest.get(taskList[0].paiban_json)
    store.commit(
      'setRecodrProductionLineChoose',
      paibanJson.plank_info
        ? paibanJson.plank_info.process_setting_name
        : paibanJson.process_setting_name
    )
    sessionStorage.setItem('isImportOrder', false as any)
    // 清空收集的多排版方案
    store.commit('paibanStore/setPaibanDataCollect', [])
    store.commit('paibanStore/clearAlreadyDealDrawData')
    store.commit('setIsTrialProduct', false)
    if (paibanJson.filterPlankList) {
      const plankList = dealPlankListLabelID(paibanJson.filterPlankList)
      store.commit('setFilterMaterialList', plankList)
      store.commit('setBeforeSearchMaterialList', plankList)
      store.commit('setBeforeSizeFilterList', plankList)
    }
    const isPreLayout = paibanJson.isPreLayout
    let nc = { status: 0 } as any
    if (isPreLayout) {
      nc = {
        status: 1,
        data: dealPreLayoutSetting(paibanJson.preLayoutSetting.setting_value),
      }
      store.commit('setOriLayoutSetting', paibanJson.preLayoutSetting)
    } else {
      nc = await fetchGetProductionNcSetting({
        setting_id: paibanJson.process_setting_id,
      })
    }
    const ncRes = nc.data

    if (nc.status) {
      store.commit('setHasSendToTask', true)
      if (paibanJson.paibanInfo) {
        store.commit(
          'setFilterMaterialList',
          paibanJson.paibanInfo.filterPlankList ?? null
        )
      } else {
        store.commit('setFilterMaterialList', null)
      }
      store.commit(
        'setPreLayoutData',
        dealPreLayoutDataLabelID(paibanJson.layoutData)
      )
      store.commit('setPaibanInfo', paibanJson.paibanInfo ?? {})
      let notOtherPlatePlank
      if (paibanJson.paibanData.length > 0) {
        store.commit('setPaibanData', paibanJson.paibanData)
        store.commit('setFinalDrawData', [])
        notOtherPlatePlank = paibanJson.paibanData.find(
          (item: any) => !item.otherPlate && !item.surplusInfo
        )
      }
      if (notOtherPlatePlank) {
        ncRes.drawPlankWidth = notOtherPlatePlank.plankWidth
        ncRes.drawPlankHeight = notOtherPlatePlank.plankHeight
      } else {
        ncRes.drawPlankWidth = ncRes.xyReverse
          ? ncRes.panelSize.plankHeight
          : ncRes.panelSize.plankWidth
        ncRes.drawPlankHeight = ncRes.xyReverse
          ? ncRes.panelSize.plankWidth
          : ncRes.panelSize.plankHeight
      }

      if (paibanJson.paibanInfo?.historyPlankEdgeOff) {
        ncRes.drawPlankEdgeOff = paibanJson.paibanInfo?.historyPlankEdgeOff
      }
      let obj = Object.assign(ncRes, {
        process_setting_id: paibanJson.process_setting_id,
        process_setting_name: paibanJson.plank_info
          ? paibanJson.plank_info.process_setting_name
          : paibanJson.process_setting_name,
      })
      store.commit('setNcSetting', obj)
      store.commit('setOrderInfo', getPlankOrderInfo(paibanJson.layoutData))
      store.commit('setIsNewPaiban', false)
      router.push({
        path: '/newPaiban',
        query: {
          from: 'history_paiabn',
          setting_id: paibanJson.process_setting_id,
        },
      })
    } else {
      Vue.prototype.$message({
        message: translate('materialPage.noProductionLine'),
        type: 'error',
        duration: 3000,
        offset: 60,
      })
      store.commit(
        'setPreLayoutData',
        dealPreLayoutDataLabelID(paibanJson.layoutData)
      )
      router.push('/materialList')
    }
  }
}

function resetSomeVuex() {
  store.commit('setFilterMaterialList', null)
  store.commit('setBeforeSearchMaterialList', null)
  store.commit('setBeforeSizeFilterList', null)
  store.commit('setFilterObject', {})
  store.commit('setMaterialTask', props.batchHistory.taskList)
  store.commit('setHasSendToTask', true)
  store.commit('setHasPrintTag', false)
  store.commit('changeHistoryStatus', false)
  store.commit('setIsShowSample', false)
  store.commit('setPaibanData', [])
  store.commit('setIsBatch', true)
}

async function handleDeleteHistory() {
  emits('onDelete', { batch_ids: [props.batchHistory.id] })
}

return { __sfc: true,props, emits, isLoading, handleToMaterial, handleToPaiban, resetSomeVuex, handleDeleteHistory, MTaskCard }
}

})